class Category {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-category').click(function () {
        $(this).next('ul').slideToggle();
        // $(this).toggleClass('active');
      });
    } 
  }
}